import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../../core/ThemeContext';

const DarkModeToggle = () => {
  const { isDarkMode, toggleDarkMode } = useTheme();

  const handleClick = (event) => {
    toggleDarkMode(event);
  };

  return (
    <motion.button
      onClick={handleClick}
      className="relative inline-flex items-center justify-center p-2 rounded-full hover:bg-primary/10 dark:hover:bg-[#FFF8D4]/20 focus:outline-none transition-all duration-200 hover:shadow-md active:scale-95"
      whileTap={{ scale: 0.9 }}
      whileHover={{ scale: 1.1 }}
      aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      <motion.div
        initial={false}
        animate={{ rotate: isDarkMode ? 40 : 0 }}
        transition={{ type: "spring", stiffness: 100 }}
        className={`w-6 h-6 ${
          isDarkMode 
            ? 'text-primary' 
            : 'text-amber-500 dark:text-amber-400'
        }`}
      >
        {isDarkMode ? (
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
            />
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
            />
          </svg>
        )}
      </motion.div>
    </motion.button>
  );
};

export default DarkModeToggle;
